import { ck, cr } from "fire-wind-water";
import { commonService } from "../services/common";
import { Subject } from "rxjs";
import { weChatService } from "../services/weChat";
import { JsonObject } from "../interface/json";
import { userService } from "../services/user";
import { meetingService } from "../services/meeting";
import { config as sconf } from "../conf/settings";
import { smkmoduleIds } from "../modules/settings/modules";

class Data {
  getJsonParams(info: any): Subject<any> {
    const $s = new Subject<any>();
    const o: any = {
      _cache_refresh: 0,
      _cache_timeout: 300,
      _cache_with_cached: 1,
    };
    cr.extend(info, o);
    commonService.getJsonParams(info).then(
      (res) => {
        if (parseInt(res.result, 10) === 0) {
          //来源管理获取最早的实例参数，保存到cookie里，提交时加入browseInfo
          this.saveSourceData(res.content);
          //this.savePreData(res.content);
          $s.next(res.content);
          $s.complete();
        } else {
          $s.next({});
          $s.complete();
        }
      },
      () => {
        $s.next({});
        $s.complete();
      }
    );
    return $s;
  }

  //记录注册表单前一次访问的实例信息
    savePreData(info: any) {
        const paramList = {
            'skModuleId': 'moduleId',
            'skInstanceId': 'instanceId',
            'skObjId': 'objId'
        };
        if (info.type !== 'instance') {
            info.moduleId = smkmoduleIds[info.type];
        }
        const modules = [1, 11];
        if (modules.indexOf(info.moduleId) !== -1 || !info.objId || info.objId === '0') {
            return false;
        }
        for (const va in paramList) {
            const temp = paramList[va];
            ck.cookie('channel_' + va, info[temp], {
                domain: sconf.domain,
                path: '/',
                expires: 2 / 1440,
            });
        }
        return true;
    }
    removeChannelCookie(list: any = {}) {
        const channelList = ck.cookie();
        // 循环遍历对象的属性
        for (const val in channelList) {
            // eslint-disable-next-line no-prototype-builtins
            if (
                channelList[val] &&
                val.indexOf("channel_") !== -1) {
                ck.removeCookie(val, { path: "/", domain: sconf.domain });
            }
        }
    }

    saveSourceData(info: any) {
        const fieldList = {
            'firstTenantId': 'tenantId',
            'firstModuleId': 'moduleId',
            'firstInstanceId': 'instanceId',
            'firstObjModuleId': 'objModuleId',
            'firstObjId': 'objId',
            'firstProgramId': 'programId',
            'firstTrack': 'track'
        };
        //如果是一个租户下的cookie，记录的首次来源是正确的，如果是新的租户，需要清空，重新记录
        const tenantId = ck.cookie("channel_firstTenantId") || null;
        if (!tenantId || tenantId !== info.tenantId) {
            this.removeChannelCookie();
        }
        const objId = ck.cookie("channel_firstObjId") || null;
        if ((objId && objId !== 0 && objId !== null) || (!info.objId || info.objId === '0')) {
            return false;
        }
        //如果是注册表单，带backUrl时，说明从某实例跳来的注册，需要记跳来的实例
        const wurl = window.location.href;
        if (info.moduleId === 11 && wurl.indexOf('backUrl=') !== -1){
            return false;
        }

        if (info.type === 'instance') {
            info.objModuleId = info.moduleId;
        } else {
            info.objModuleId = smkmoduleIds[info.type];
        }
        if (info.module){
            info.moduleId = info.module;
        }
        //首次进入加是否是渠道来的标识
        info.track = (wurl.indexOf('track_id') !== -1 || wurl.indexOf('markCode') !== -1) ? 1 : 0;
        info.programId = info.programId || '';
        info.objectTitle = '';
        for (const valf in fieldList) {
            const temp = fieldList[valf];
            ck.cookie('channel_' + valf, info[temp], {
                domain: sconf.domain,
                path: '/',
            });
        }
        return true;
    }

  getWxcode(info: any): Subject<any> {
    const $s = new Subject<any>();
    weChatService.getWxcode(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  getCode(info: JsonObject): Subject<any> {
    const $s = new Subject<any>();
    weChatService.getCode(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  getOAuth(info: JsonObject): Subject<any> {
    const $s = new Subject<any>();
    weChatService.getOAuth(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  getId(info: JsonObject): Subject<any> {
    const $s = new Subject<any>();
    userService.getId(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  getByOpenId(info: JsonObject): Subject<any> {
    const $s = new Subject();
    weChatService.getByOpenId(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  checkSess(info: JsonObject): Subject<any> {
    const $s = new Subject();
    userService.checkSess(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(true);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  weChatQrCode(info: JsonObject): Subject<any> {
    const $s = new Subject();
    weChatService.weChatQrCode(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  getForNewForm(info: JsonObject): Subject<any> {
    const $s = new Subject();
    meetingService.getForNewForm(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  getCustomForm(info: JsonObject): Subject<any> {
    const $s = new Subject();
    meetingService.getCustomForm(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  getWebinar(info: JsonObject): Subject<any> {
    const $s = new Subject();
    meetingService.getWebinar(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  getSeminar(info: JsonObject): Subject<any> {
    const $s = new Subject();
    meetingService.getSeminar(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  checkRegistration(info, key): Subject<any> {
    const $s = new Subject();
    userService.checkRegistration(info, key).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }

  getTmpImg(info): Subject<any> {
    const $s = new Subject();
    weChatService.getImg(info).then(
      (data) => {
        if (parseInt(data.result, 10) === 0) {
          $s.next(data.content);
        } else {
          $s.next(null);
        }
        $s.complete();
      },
      () => {
        $s.next(null);
        $s.complete();
      }
    );
    return $s;
  }
}

export const data = new Data();
